export default function Legal({ title, children }) {
  return (
    <section className="static-page">
      <p className="chapter-tag"><em>Legal</em></p>
      <h1 className="page-h1">{title}</h1>
      <div className="legal-body">{children}</div>
    </section>
  );
}

export function Privacy() {
  return (
    <Legal title="Privacy Policy">
      <p>Bhoomiza Organics respects your privacy. We only collect information you provide during checkout — name, phone, email, delivery address — to fulfil your order. We do not sell or share your personal information with third parties beyond what is required for delivery and payment processing (Razorpay).</p>
      <p>Payment information is processed by Razorpay and never stored on our servers. For any privacy-related requests, please contact us via WhatsApp.</p>
    </Legal>
  );
}

export function Terms() {
  return (
    <Legal title="Terms &amp; Conditions">
      <p>By placing an order with Bhoomiza Organics you agree to receive delivery updates via WhatsApp/phone and confirm the address you provided. Products are naturally made; batch appearance may vary slightly. We do not make any medical claims. Please consult a health professional before making dietary changes.</p>
      <p>Orders can be cancelled before dispatch by contacting us on WhatsApp. Refunds are handled through the original payment method.</p>
    </Legal>
  );
}
